import styles from './GridCell.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Blurb } from 'src/components/Contentful/Blurb';
import { ContentfulImage } from 'src/components/Contentful/ContentfulImage';
import { Text } from 'src/components/Contentful/Text';

interface IGridCellProps extends React.AllHTMLAttributes<HTMLElement>{
  entry?: ReferencedEntry<Subject>;
  innerRef?: React.Ref<HTMLDivElement>;
}

export const GridCell: React.FC<IGridCellProps> = ({
  entry, className, innerRef, ...props
}) => {
  if (!entry || !entry.fields) return null;

  const { image } = entry.fields;

  return (
    <div className={cx(className, styles.gridCell)} ref={innerRef} {...props}>
      <div className={styles.imageWrapper}>
        <ContentfulImage
          autoHeight
          asset={image}
          className={styles.image}
        />
      </div>
      <Text tagName="h5" entry={entry} field="title" className={styles.title} />
      <Blurb entry={entry} field="blurb" />
    </div>
  );
};
